import React from 'react';
import { QuoteModalProvider } from './contexts/QuoteModalContext';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { TrustBadges } from './components/TrustBadges';
import { Services } from './components/Services';
import { BeforeAfter } from './components/BeforeAfter';
import { CallBanner } from './components/CallBanner';
import { HowItWorks } from './components/HowItWorks';
import { PainSection } from './components/PainSection';
import { DreamSection } from './components/DreamSection';
import { Differentiators } from './components/Differentiators';
import { ServiceAreas } from './components/ServiceAreas';
import { Proof } from './components/Proof';
import { Reviews } from './components/Reviews';
import { Guarantee } from './components/Guarantee';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { QuoteModal } from './components/QuoteModal';
import { QuoteLauncher } from './components/QuoteLauncher';
export function App() {
  return <QuoteModalProvider data-id="element-0" data-mp="3ijpcuzwkmx98">
      <div className="w-full bg-white font-sans text-ink-900" data-id="element-1" data-mp="3mljat0fdtn5p">
        <Header data-id="element-2" data-mp="3mjztd6hzp62c" />
        <main data-id="element-3" data-mp="3mjg93j4va5l5">
          <Hero data-id="element-4" data-mp="3rc9e8848zfxr" />
          <TrustBadges data-id="element-5" data-mp="3rbra6pbcfxfa" />
          <Services data-id="element-6" data-mp="3rdatkosaqola" />
          <BeforeAfter data-id="element-7" data-mp="3rd1azm9kzjpm" />
          <CallBanner headline="Got a pile like that? We can be there tomorrow." sub="Free quote over the phone — same-day service often available." data-id="element-8" data-mp="3relvsk63foaa" />
          <HowItWorks data-id="element-9" data-mp="2zm4vedw4z0yn" />
          <PainSection data-id="element-10" data-mp="2zmwguvw0rib7" />
          <DreamSection data-id="element-11" data-mp="33mouhn09senf" />
          <Differentiators data-id="element-12" data-mp="33m5bs42spm8c" />
          <ServiceAreas data-id="element-13" data-mp="33ngfy505kvzz" />
          <Proof data-id="element-14" data-mp="33orjq4tlm3r3" />
          <Reviews data-id="element-15" data-mp="38lrq6gud18iq" />
          <Guarantee data-id="element-16" data-mp="38l8h7pmotugu" />
          <FinalCTA data-id="element-17" data-mp="38l04bxqkep5n" />
        </main>
        <Footer data-id="element-18" data-mp="38nupxslbeg0n" />
        <QuoteLauncher data-id="element-19" data-mp="3dkuw03i5zirr" />
        <QuoteModal data-id="element-20" data-mp="3dl4lzr37lpxg" />
      </div>
    </QuoteModalProvider>;
}